export default function WhatIsTalentPool() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что такое кадровый резерв
        </h2>
        <p className="text-teal-700 font-semibold text-center text-base md:text-lg mb-10">
          Кадровый резерв — это не список «лучших сотрудников»
        </p>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          <div>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-6">
              Кадровый резерв — это система выявления и подготовки сотрудников, которые потенциально могут занять определённые должности или взять на себя дополнительные зоны ответственности.
            </p>
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              Важно разделять два понятия: <strong className="font-semibold">потенциал сотрудника</strong> и <strong className="font-semibold">готовность к новой должности</strong>. Сотрудник может обладать высоким потенциалом, но пока не иметь необходимых компетенций.
            </p>
            <p className="text-base text-gray-700 leading-relaxed">
              Поэтому задача кадрового резерва — не просто выбрать перспективных людей, а создать условия, в которых они смогут подготовиться к будущей роли.
            </p>
          </div>

          <div className="bg-gray-50 rounded-2xl border border-gray-200 p-6 md:p-8">
            <h3 className="text-lg font-bold text-gray-900 mb-6">Ключевое различие</h3>
            <div className="space-y-5">
              <div className="bg-white border border-gray-200 rounded-xl p-4">
                <div className="flex items-center gap-2 mb-2">
                  <i className="ri-user-star-line text-teal-600"></i>
                  <span className="text-xs font-semibold text-teal-700 uppercase tracking-wide">Потенциал</span>
                </div>
                <p className="text-sm text-gray-700 leading-relaxed">
                  Способность сотрудника развиваться и расти. Высокий потенциал не означает, что человек уже готов к новой роли.
                </p>
              </div>
              <div className="flex justify-center">
                <i className="ri-arrow-down-line text-teal-600 text-xl"></i>
              </div>
              <div className="bg-white border border-gray-200 rounded-xl p-4">
                <div className="flex items-center gap-2 mb-2">
                  <i className="ri-checkbox-circle-line text-teal-600"></i>
                  <span className="text-xs font-semibold text-teal-700 uppercase tracking-wide">Готовность</span>
                </div>
                <p className="text-sm text-gray-700 leading-relaxed">
                  Наличие компетенций, необходимых для выполнения будущей роли. Именно к готовности приводит система кадрового резерва.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}